import FetchService from './fetch.service';
import localStorageService from "./localStorage.service";
class datalayerguardService {
    startDatalayerGuard = async ({ scenarioIds = null, onMessageStep, onMessage, onScreencast, onOpen, onError, onClose,finishTest, onResults, onProgress } = {}) => {
        const companyId = localStorageService.getCompanyId()
        const fetchService = new FetchService();
        const jobId = crypto.randomUUID()
        localStorageService.setDLGJobId(jobId);
        const body = { company_id: companyId, jobId};
        if (scenarioIds && scenarioIds.length > 0) body.scenarioIds = scenarioIds;
        const response = await fetchService("/configurations/datalayerGuard/start", {
            method: 'POST',
            cache: 'no-cache',
            mode: 'cors',
            body: JSON.stringify(body),
            headers: {
                'Accept': 'application/json',
                "Content-Type": 'application/json',
            },
            credentials: 'include',
        });
        const respData = await response.json();
        if (respData?.executionNames?.length) {
            localStorageService.setDLGExecutionNames(respData.executionNames);
        }
        let token = (respData?.token) ? respData.token : null;
        const {ws} = await this.webSocketHelper({ onMessageStep, onMessage, onScreencast, onOpen, onError, onClose, finishTest, onResults, onProgress, token, jobId })
        
        return { ws, result: respData?.result || "error" };
    }
    stopDatalayerGuard = async () => {
        const companyId = localStorageService.getCompanyId();
        const jobId = localStorageService.getDLGJobId();
        const executionNames = localStorageService.getDLGExecutionNames();
        const fetchService = new FetchService();
        const response = await fetchService("/configurations/datalayerGuard/stop", {
            method: 'POST',
            cache: 'no-cache',
            mode: 'cors',
            body: JSON.stringify({ company_id: companyId, jobId, runType: "testRun", executionNames }),
            headers: {
                'Accept': 'application/json',
                "Content-Type": 'application/json',
            },
            credentials: 'include',
        });
        await response.json();
        localStorageService.setDLGExecutionNames([]);
    }
    webSocketHelper = async ({ onMessageStep, onMessage, onScreencast, onOpen, onError, onClose,finishTest, onResults, onProgress, token, jobId  } = {}) => {
        let url = (process.env.NODE_ENV !== 'production') ? "ws://localhost:8080/portal/":  "wss://cc-datalayer-guard-relay-service-742494064657.europe-west3.run.app/portal/";
        const wsUrl = `${url}?token=${token}&jobId=${jobId}&role=portal`;
        const ws = new WebSocket(wsUrl);
        ws.onopen = () => {
            onOpen?.();
        };
        ws.onmessage = (event) => {
            if (event.data instanceof Blob) {
                const blobUrl = URL.createObjectURL(event.data);
                onScreencast?.(blobUrl);
            } else {
                const data = JSON.parse(event.data);
                // console.log(...data)
                switch (data.type) {
                    case 'step':
                        data.message.text = `Step ${data?.message.stepNumber} completed`;
                        onMessageStep?.(data);
                        break;
                    case 'step_error':
                        data.message.text = `Step ${data?.message.stepNumber} failed`;
                        onMessageStep?.(data);
                        break;
                    case 'info':
                        console.error("step message: ", data)
                        break;
                     case 'info_stop_by_user':
                        data.message = { text: 'Datalayer Guard received stop command, stopping gracefully...' };
                        onMessage?.(data);
                        break;
                    case 'info_finished':
                        data.message = { text: 'The DataLayer Guard has finished testing all scenarios.' };
                        onMessage?.(data);
                        break;
                    case 'error':
                        console.error("step message: ", data)
                        break;
                    // case 'error_unable_to_crawl':
                    //     data.message.text = `The DLG was unable to check "${data.message.vars.urlStartingPoint}" while setting up the "${data.message.vars.scenarioTitle}" scenario.`;
                    //     onMessage?.(data);
                    //     break;
                    case 'error_unable_to_navigate_starting_point':
                        data.message.text = `Error: The Datalayer Guard could not open the starting page.`;
                        data.message.debugInfo = `While setting up the "${data.message.vars.scenarioTitle}" scenario, the Datalayer Guard could not open the starting page "${data.message.vars.urlStartingPoint}".`;
                        data.message.tip = `Make sure the URL is publicly reachable and not behind a login or firewall. Also verify the URL matches the type you selected (hostname, page URL, or page path) and does not contain typos.`;
                        onMessage?.(data);
                        break;
                    case 'error_unable_to_navigate':
                        data.message.text = `Error: The Datalayer Guard was unable to load the page.`;
                        data.message.debugInfo = `While testing step "${data.message.vars.stepNumber}" of the "${data.message.vars.scenarioTitle}" scenario, the Datalayer Guard was unable to load the page "${data.message.vars.stepValue}".`;
                        data.message.tip = `Check that the URL in this step is correct and reachable. The page may be returning an error, redirecting unexpectedly, or taking too long to respond.`;
                        onMessage?.(data);
                        break;
                    case 'error_page_not_loaded':
                        data.message.text = `Error: The page did not load in time.`;
                        data.message.debugInfo = `While testing step "${data.message.vars.stepNumber}" of the "${data.message.vars.scenarioTitle}" scenario, the browser was still on a blank page.`;
                        data.message.tip = `The page took too long to respond and the Datalayer Guard timed out. This can happen due to slow server response, large page assets, or a network issue. Try increasing the timeout or checking the page performance.`;
                        onMessage?.(data);
                        break;
                    case 'error_step_action_failed':
                        data.message.text = `Warning: "${data.message.vars.stepType}" action failed.`;
                        data.message.debugInfo = `While testing step "${data.message.vars.stepNumber}" of the "${data.message.vars.scenarioTitle}" scenario, the "${data.message.vars.stepType}" action failed on "${data.message.vars.resultUrl}".`
                        onMessage?.(data);
                        break;
                    case 'error_datalayer_not_found':
                        data.message.text = `Error: The Datalayer Guard could not find the dataLayer.`;
                        data.message.debugInfo = `While testing step "${data.message.vars.stepNumber}" of the "${data.message.vars.scenarioTitle}" scenario, the Datalayer Guard could not find the dataLayer on "${data.message.vars.resultUrl}".`;
                        data.message.tip = `This may be due to the page not loading correctly or the dataLayer being named differently. Please check if the page loads properly and if the dataLayer variable is present.`;
                        onMessage?.(data);
                        break;
                    case 'error_datalayers_paramaters':
                        data.message.text = `Error: The Datalayer Guard found a parameter error in your dataLayer.`;
                        data.message.debugInfo = `While checking the dataLayer with event "${data.message.vars?.eventName}" on "${data.message.vars?.resultUrl}". Parameter name: "${data.message.vars?.parameters?.[0]?.parameter_name}", expected type: "${data.message.vars?.parameters?.[0]?.expected_type}", expected value: "${data.message.vars?.parameters?.[0]?.expected_value}", actual type: "${data.message.vars?.parameters?.[0]?.actual_type}", actual value: "${data.message.vars?.parameters?.[0]?.actual_value}".`;
                        data.message.tip = `This may be due to a mismatch between the dataLayer push and the template you set up. Please check if the event "${data.message.vars?.eventName}" is pushed with the correct parameters as defined in your template.`;
                        onMessage?.(data);
                        break;
                    case 'system':
                        console.error("step message: ", data)
                        break;
                    case 'system_started':
                        data.message.text = 'System is starting...';
                        onMessage?.(data);
                        break;
                    case 'datalayer':
                        console.error("step message: ", data)
                        break;
                    case 'datalayer_datalayer_found':
                        data.message.text = `DataLayer found on ${data.message.vars.url} with event name: "${data.message.vars.eventName}".`;
                        onMessage?.(data);
                        break;
                    case 'scenario':
                        console.error("step message: ", data)
                        break;
                    case 'scenario_started':
                        data.message.text = `Testing scenario: "${data.message.scenarioTitle}"`;
                        onMessage?.(data);
                        break;
                    case 'scenario_finished_successfully':
                        data.message.text = `The "${data.message.vars.scenarioTitle}" scenario finished successfully with no errors.`;
                        onMessage?.(data);
                        break;
                    case 'scenario_finished_with_errors':
                        data.message.text = `The "${data.message.vars.scenarioTitle}" scenario finished with ${data.message.vars.scenarioErrors} error${data.message.vars.scenarioErrors > 1 ? 's' : ''}.`;
                        onMessage?.(data);
                        break;
                    case 'progress':
                        onProgress?.(data);
                        break;
                    case 'results':
                        onResults?.(data);
                        break;
                    case 'finished':
                        finishTest?.();
                        break;
                    case 'error_auth_failed':
                        data.message = { text: 'The DataLayer Guard could not start: authentication failed.' };
                        onMessage?.(data);
                        finishTest?.();
                        break;
                    default:
                        onMessage?.(data);
                }     
            }
        };
        ws.onerror = (error) => {
            onError?.(error);
        };
        ws.onclose = () => {
            onClose?.();
            ws.close();
        };
        return {ws: ws}
    }
};

export default new datalayerguardService();